import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import ChangeUserByVpsComponent from "../../../../components/Customer/vps/ChangeUserByVpsComponent";

const PageChangeUserByVps = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ChangeUserByVpsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default PageChangeUserByVps;